import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getStoreApi } from '../../../plugins/helper';
import {
  setAccessToken,
  setFullName,
  set_language,
  setPermissions,
  setRoleTitle,
  setRoleTitleAdmin,
  setTenantId
} from "../../../core/redux/action";
import {loadResources, loadCategoriesAndDropDown} from "../../../api/translation.js";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
// import { APIGetUserLocations } from "../../../api/stores.ts";
import { updateProfile } from "../../../apirapper/user.ts";

import { APIAuthenticateSSO } from "../../../api/authSSO.ts";
import { useNavigate } from "react-router-dom";
// import { APIgetStores } from "../../../api/settings.ts";
import { requestForToken } from "../../../firebase";
import "./styles.css";

// import { getUrls } from "../../../api/apiurls.js";

const SignIn = () => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const languages = useSelector((state) => state.languages || []);
  const [, setCount] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const storedEmail = localStorage.getItem("rememberedEmail");
    if (storedEmail) {
      setEmail(storedEmail);

      setRememberMe(true);
    }
  }, []);
  //   const googleLogin = () => {
  //     const sso = getUrls().sso;
  //     const hostApp = location.protocol + "//" + location.host;
  //     const url = `${sso}/api/authGoogle?hostapp=${hostApp}`;
  //     window.open(url, '_blank');

  // };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, email: false }));
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, password: false }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  const validateForm = () => {
    const errors = {};
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
      errors.email = t?.[l]?.["email_is_required"] || "Email is required";
    } else if (!emailPattern.test(email)) {
      errors.email =
        t?.[l]?.["invalid_email_address"] || "Invalid email address";
    }
    if (!password) {
      errors.password =
        t?.[l]?.["password_is_required"] || "Password is required";
    }
    return errors;
  };

  const route = all_routes;
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setErrors({}); // Clear previous errors if any

    try {
      const response = await APIAuthenticateSSO({
        username: email,
        password: password,
      });
      if (response.status?.toString() !== "200") {
        throw new Error("Authentication failed");
      }

      const accessToken = response.response?.authentication?.access_token;
      const fullName = response.response?.profile?.fullName;
      const getPermissions = response.response?.role?.permissions;
      const roleTitle = response.response?.role?.title;
      const userId = response.response?._id;
      const tenantId = response?.response?.tenant?._id || null;

      let permissions;
      if (getPermissions && getPermissions.length > 0) {
        permissions = getPermissions.map((item) => {
          const parts = item.title.split(":");
          const module = parts[1];
          const permission = parts[3];
          return {
            Module: module.trim(),
            Permission: permission.trim(),
          };
        });
      }
      if (accessToken) {
        dispatch(setAccessToken(accessToken));
        dispatch(setFullName(fullName));
        dispatch(setPermissions(permissions));
        dispatch(setRoleTitle(roleTitle));
        localStorage.setItem("roleTitle", roleTitle);
        localStorage.setItem("userId", userId?.toLowerCase());
        localStorage.setItem("tenantId", tenantId);
        
        dispatch(setTenantId(tenantId));
        dispatch(setRoleTitleAdmin("TenantAdmin"));
        
        await getStoreApi(roleTitle);
        if (rememberMe) {
          localStorage.setItem("rememberedEmail", email);
        } else {
          localStorage.removeItem("rememberedEmail");
        }
        console.log("tenantId before loadResources and loadCategoriesAndDropDown", tenantId);
        await loadResources(tenantId);
        await loadCategoriesAndDropDown(tenantId);
        
        try {
          const fcmToken = await requestForToken();
          const tokenData = { id: fcmToken, os: "web" };
          const updatedData = {};
          updatedData.device = tokenData;
          await updateProfile(updatedData);
        } catch (error) {
          console.error("fcmToken Error", error);
        }
console.log("update profile, before navigation");
        navigate(route.saleslist);
        console.log("after navigation");
      }
    } catch (error) {
      console.error("SignIn Error", error);
      setErrors({ general: "Invalid email or password" });
    }
  };

  const serverChange = () => {
    setCount((prev) => {
      const newCount = prev + 1;
      const serverOn = localStorage.getItem("on") || 'stg';
      const on = serverOn === "stg" || !serverOn ? "prod" : "stg";
      if (newCount === 5) {
        const tenantId = localStorage.getItem("tenantId")
        localStorage.clear();
        localStorage.setItem("tenantId", tenantId);
        localStorage.setItem("on", on);
        window.location.reload();
      }
      return newCount;
    });
    setTimeout(() => {
      setCount(0);
    }, 3000);
  };
  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
          <div
            className="login-img"
            style={{
              position: "relative",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src="assets/img/authentication/login02.png"
              style={{ marginLeft: "2%" }}
              alt="img"
            />

            <div
              className="overlay"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "60%",
                height: "60%",
                border: "1px solid",
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                textAlign: "center",
                transform: "translate(-50%, -50%)",
                backdropFilter: "blur(10px)", // Adds blur effect
              }}
            >
              <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                {t?.[l]?.["welcome!"] || "Welcome!"}
              </h1>
              <p
                style={{
                  fontSize: "1.2rem",
                  maxWidth: "80%",
                  lineHeight: "1.5",
                }}
              >
                {t?.[l]?.["stock_up_smart_save_big_always"] ||
                  "Stock Up Smart, Save big Always!"}
                <br />
                {t?.[l]?.["your_inventory_our_expertise"] ||
                  "Your Inventory, Our Expertise"}
              </p>
            </div>
          </div>

          <div className={`login-content ${l === "ar" ? "rtl" : "ltr"}`}>
            <form style={{ width: "80%" }} onSubmit={handleSubmit}>
              <div className="login-userset">
                {/* <div className="login-logo logo-normal">
                  
                <span className={`${l === 'ar' ? 'hidden' : ''}`}>{t?.[l]?.["select_language"] || "Select Language"}</span>
                <span className={`${l === 'ar' ? 'hidden' : ''}`}>{t?.[l]?.["select_language"] || "Select Language"}</span>

                 </div> */}

                <div className="login-userheading">
                  <h3 onClick={serverChange} style={localStorage.getItem('on') == 'prod' ? {} : {color:"red"}}>
                    {t?.[l]?.["sign_in"] || "Sign In"}
                  </h3>
                  <h4>
                    {t?.[l]?.[
                      "access_the_admin_panel_using_your_email_and_passcode."
                    ] ||
                      "Access the admin panel using your email and passcode."}
                  </h4>
                </div>
                <div className="form-login">
                  <label>{t?.[l]?.["email_address"] || "Email Address"}</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={handleEmailChange}
                    />
                    <ImageWithBasePath
                      className={`${l === "ar" ? "rtl hidden" : "ltr"}`}
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                  {errors.email && (
                    <span className="error-message" style={{ color: "red" }}>
                      {errors.email}
                    </span>
                  )}
                </div>
                <div className="form-login">
                  <label>{t?.[l]?.["password"] || "Password"}</label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="pass-input"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    <span
                      className={`fas toggle-password ${
                        l === "ar" ? "rtl hidden" : "ltr"
                      } ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  {errors.password && (
                    <span className="error-message" style={{ color: "red" }}>
                      {errors.password}
                    </span>
                  )}
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-6">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                          />
                          <span className="checkmarks" />
                          {t?.[l]?.["remember_me"] || "Remember me"}
                        </label>
                      </div>
                    </div>
                    <div className="col-6 text-end">
                      {/* <Link className="forgot-link" to={route.forgotPasswordTwo}>
                      {t?.[l]?.["forgot_password?"] || "Forgot Password?"}
                      </Link> */}
                    </div>
                  </div>
                </div>
                {errors.general && (
                  <span className="error-message" style={{ color: "red" }}>
                    {errors.general}
                  </span>
                )}
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    {" "}
                    {t?.[l]?.["sign_in"] || "Sign In"}
                  </button>
                </div>
                {/* <div className="signinform">
                  <h4>
                    New on our platform?
                    <Link to={route.registerTwo} className="hover-a"> Create an account</Link>
                  </h4>
                </div> */}
                {/* <div className="form-setlogin or-text">
                  <h4>OR</h4>
                </div> */}
                <div className="form-sociallink">
                  {/* <ul className="d-flex">
                    <li style={{width:"100%"}}>
                      <Link onClick={googleLogin}>
                        <ImageWithBasePath src="assets/img/icons/google.png" alt="Google" />
                      </Link>
                    </li>
                  </ul> */}
                  <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span style={{ flexGrow: 1 }}>
                        {t?.[l]?.[
                          "copyright_©_2024_wizztech._all_rights_reserved"
                        ] || "Copyright © 2024 WizzTech. All rights reserved"}
                      </span>
                      <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
                        <Link
                          to="#"
                          className="nav-link select-store"
                          data-bs-toggle="dropdown"
                        >
                          <span
                            className="user-info"
                            style={{
                              gap: l === "ar" ? "10px" : "",
                              padding: "3px 30px 0 0",
                            }}
                          >
                            {l === "ar"
                              ? t?.[l]?.["arabic"]
                              : t?.[l]?.["english"]}
                          </span>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                          {languages.map((itm) => (
                            <Link
                              to="#"
                              className="dropdown-item"
                              key={itm.key}
                              style={{
                                width: "100%",
                                height: "20px",
                                padding: "15px",
                              }}
                              onClick={() => {
                                dispatch(set_language(itm.key));
                                localStorage.setItem("language", itm.key);
                                localStorage.setItem("lang", itm.key);
                              }}
                            >
                              {t?.[l]?.[itm.name.toLowerCase()]}
                            </Link>
                          ))}
                        </div>
                      </li>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;